(function() {
    'use strict';

    angular.module('app.departamentos', []);
})();
